var map = {
	"./P2-C1.svg": "b75a",
	"./P2-C2.svg": "5af4",
	"./P2-C3.svg": "db6b",
	"./P2-C4.svg": "a898",
	"./P2-C5.svg": "dca3",
	"./P2-C6.svg": "1d8b",
	"./P2-C7.svg": "d9cb",
	"./P2-C8.svg": "fd5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc60";